import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/pages/teacher/Login/Login.js");
